/**
 * Prefijos telefónicos del formulario de registro.
 *
 * Generado desde `cuentas/paises.py`, que es la fuente: el backend valida
 * contra su propia lista y un ISO que no esté allí se rechaza. Si hay que
 * añadir un país, se añade allí y se regenera este archivo.
 */

export interface Pais {
  iso: string
  nombre: string
  prefijo: string
}

export const PAISES: readonly Pais[] = [
  { iso: 'CL', nombre: 'Chile', prefijo: '+56' },
  { iso: 'AR', nombre: 'Argentina', prefijo: '+54' },
  { iso: 'BO', nombre: 'Bolivia', prefijo: '+591' },
  { iso: 'BR', nombre: 'Brasil', prefijo: '+55' },
  { iso: 'CO', nombre: 'Colombia', prefijo: '+57' },
  { iso: 'CR', nombre: 'Costa Rica', prefijo: '+506' },
  { iso: 'CU', nombre: 'Cuba', prefijo: '+53' },
  { iso: 'DO', nombre: 'República Dominicana', prefijo: '+1' },
  { iso: 'EC', nombre: 'Ecuador', prefijo: '+593' },
  { iso: 'SV', nombre: 'El Salvador', prefijo: '+503' },
  { iso: 'GT', nombre: 'Guatemala', prefijo: '+502' },
  { iso: 'HN', nombre: 'Honduras', prefijo: '+504' },
  { iso: 'MX', nombre: 'México', prefijo: '+52' },
  { iso: 'NI', nombre: 'Nicaragua', prefijo: '+505' },
  { iso: 'PA', nombre: 'Panamá', prefijo: '+507' },
  { iso: 'PY', nombre: 'Paraguay', prefijo: '+595' },
  { iso: 'PE', nombre: 'Perú', prefijo: '+51' },
  { iso: 'PR', nombre: 'Puerto Rico', prefijo: '+1' },
  { iso: 'UY', nombre: 'Uruguay', prefijo: '+598' },
  { iso: 'VE', nombre: 'Venezuela', prefijo: '+58' },
  { iso: 'US', nombre: 'Estados Unidos', prefijo: '+1' },
  { iso: 'CA', nombre: 'Canadá', prefijo: '+1' },
  { iso: 'ES', nombre: 'España', prefijo: '+34' },
  { iso: 'PT', nombre: 'Portugal', prefijo: '+351' },
  { iso: 'GB', nombre: 'Reino Unido', prefijo: '+44' },
  { iso: 'IE', nombre: 'Irlanda', prefijo: '+353' },
  { iso: 'FR', nombre: 'Francia', prefijo: '+33' },
  { iso: 'DE', nombre: 'Alemania', prefijo: '+49' },
  { iso: 'IT', nombre: 'Italia', prefijo: '+39' },
  { iso: 'NL', nombre: 'Países Bajos', prefijo: '+31' },
  { iso: 'BE', nombre: 'Bélgica', prefijo: '+32' },
  { iso: 'CH', nombre: 'Suiza', prefijo: '+41' },
  { iso: 'SE', nombre: 'Suecia', prefijo: '+46' },
  { iso: 'NO', nombre: 'Noruega', prefijo: '+47' },
  { iso: 'FI', nombre: 'Finlandia', prefijo: '+358' },
  { iso: 'PL', nombre: 'Polonia', prefijo: '+48' },
  { iso: 'AU', nombre: 'Australia', prefijo: '+61' },
  { iso: 'NZ', nombre: 'Nueva Zelanda', prefijo: '+64' },
  { iso: 'ZA', nombre: 'Sudáfrica', prefijo: '+27' },
  { iso: 'CN', nombre: 'China', prefijo: '+86' },
  { iso: 'JP', nombre: 'Japón', prefijo: '+81' },
  { iso: 'KR', nombre: 'Corea del Sur', prefijo: '+82' },
  { iso: 'IN', nombre: 'India', prefijo: '+91' },
]

export const PAIS_POR_DEFECTO = 'CL'
